var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddingVendorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11950",
    transform: "translate(-675 -475.175)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 340",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(675 475.175)",
    style: {
      fill: "#e65aff"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11951"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11950"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5351",
    d: "M698.607 486.785v-1.816h-1.816v1.816h-1.816v1.816h1.816v1.816h1.816v-1.816h1.816v-1.816z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5352",
    d: "M685.896 489.508a3.632 3.632 0 1 0-3.632-3.631 3.631 3.631 0 0 0 3.632 3.631z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5353",
    d: "M685.895 490.416c-2.424 0-7.263 1.217-7.263 3.632v2.724h14.527v-2.724c0-2.415-4.84-3.632-7.264-3.632z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5354",
    d: "M689.99 482.29a5.43 5.43 0 0 1 0 7.173 3.614 3.614 0 0 0 0-7.173z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5355",
    d: "M693.64 491.17a3.847 3.847 0 0 1 1.335 2.878v2.724h1.815v-2.724c0-1.316-1.443-2.279-3.15-2.878z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddingVendorIcon);
export default __webpack_public_path__ + "static/media/adding_vendor_icon.ce69de97fac0a1e353f06ca057fa6234.svg";
export { ForwardRef as ReactComponent };